import { FC } from "react";
import {
  SkeletonCard,
  SkeletonCardWrapper,
  SkeletonGameName,
  SkeletonGameWrapper,
  SkeletonStudio,
} from "./styled";

export interface SkeletonProps {
  width: string;
  height: string;
  marginLeft?: string;
}

export const GameCardSkeleton: FC<SkeletonProps> = ({
  width,
  height,
  marginLeft,
}) => (
  <SkeletonCardWrapper marginLeft={marginLeft}>
    <SkeletonCard width={width} height={height} />
    <SkeletonGameWrapper>
      <SkeletonGameName />
      <SkeletonStudio />
    </SkeletonGameWrapper>
  </SkeletonCardWrapper>
);
